module.exports = __webpack_public_path__ + "static/BAM-banner.7f2e43ab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/banners/BAM-banner.jpg
// module id = 1457
// module chunks = 25315682503253